import type {
  AiClearCacheResult,
  AiEditBuilderSectionInput,
  AiEditBuilderSectionResult,
  AiGenerateBuilderPageInput,
  AiGenerateBuilderPageResult,
  AiModelRecord,
  AiProviderKeyInput,
  AiProviderKeyStatusRecord,
  AiProviderKeyTestInput,
  AiProviderKeyTestResult
} from '@shared/types';
import { getDesktopApi } from '@renderer/lib/desktop-api';

export async function listAiModels(): Promise<AiModelRecord[]> {
  return getDesktopApi().ai.listModels();
}

export async function getAiProviderKeyStatus(): Promise<AiProviderKeyStatusRecord> {
  return getDesktopApi().ai.getProviderKeyStatus();
}

export async function setAiProviderKey(payload: AiProviderKeyInput): Promise<AiProviderKeyStatusRecord> {
  return getDesktopApi().ai.setProviderKey(payload);
}

export async function testAiProviderKey(payload: AiProviderKeyTestInput): Promise<AiProviderKeyTestResult> {
  return getDesktopApi().ai.testProviderKey(payload);
}

export async function generateBuilderPageWithAi(
  payload: AiGenerateBuilderPageInput
): Promise<AiGenerateBuilderPageResult> {
  return getDesktopApi().ai.generateBuilderPage(payload);
}

export async function editBuilderSectionWithAi(
  payload: AiEditBuilderSectionInput
): Promise<AiEditBuilderSectionResult> {
  return getDesktopApi().ai.editBuilderSection(payload);
}

export async function clearAiCache(): Promise<AiClearCacheResult> {
  return getDesktopApi().ai.clearCache();
}
